import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, isNewUser } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" />;
  } else if (isNewUser) {
    return <Navigate to="/authentication/complete-registration" />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
